import React from "react";
import { useTheme } from "styled-components";
import { FooterThreeDesktopCont } from "./styled.styles";
import Image from "componentReusable/Image";
import downloadLinks from "config/JSON/DownloadPage/downloadAppLinkDesktop.json";
import { gtmDownloadApp } from "GTMs/actions/commonActions";

interface IFooterThreeDesktop {
  huaweiLink?: string;
  googleLink?: string;
  appleLink?: string;
}

const FooterThreeDesktop = ({
  huaweiLink,
  googleLink,
  appleLink,
}: IFooterThreeDesktop) => {
  const { translations, locale } = useTheme();
  const { googlePlayStore, huaweiStore, appleStore } = downloadLinks.footer;
  return (
    <FooterThreeDesktopCont id="footerThreeDesktop" className="borderTop">
      <div className="width-1200 m-auto relative flex flexSpaceBetween">
        <div className="fasterEasierFree pt-16 pb-16">
          {translations.fasterEasierFree}
          <strong className="block mt-16">{translations.downloadAppPage.downloadOpenSooqApp}</strong>
          <div className="flex mt-16">
            <a
              className="me-8"
              href={huaweiLink ? huaweiLink : huaweiStore}
              onClick={() => gtmDownloadApp("Huawei")}
              aria-label="Download App"
            >
              <Image
                src={`/images/downloadAppButtons/appGallery.webp`}
                imageType="png"
                width="177"
                height="51"
                alt="App Gallery"
                loading="lazy"
              />
            </a>
            <a
              className="me-8"
              href={googleLink ? googleLink : googlePlayStore}
              onClick={() => gtmDownloadApp("Android")}
              aria-label="Download App"
            >
              <Image
                src={`/images/downloadAppButtons/googlePlay.webp`}
                imageType="png"
                width="177"
                height="51"
                alt="Google Play"
                loading="lazy"
              />
            </a>
            <a
              href={appleLink ? appleLink : appleStore}
              onClick={() => gtmDownloadApp("iOS")}
              aria-label="Download App"
            >
              <Image
                src={`/images/downloadAppButtons/appStore.webp`}
                imageType="png"
                width="177"
                height="51"
                alt="App Store"
                loading="lazy"
              />
            </a>
          </div>
        </div>
        <div className="qrApp flex flexDirectionColumn pt-16 gap-5 center font-18 ">
          {translations.qrCode.section1}
          <Image
            src={`/images/downloadAppButtons/qrOpenSooq.webp`}
            imageType="png"
            alt={"qr"}
            width="90"
            height="90"
            loading="lazy"
          />
        </div>
        <Image
          src={`/images/downloadAppButtons/diagonal-${locale}.webp`}
          imageType="png"
          alt={"OpenSooq - السوق المفتوح"}
          className="slantPhone"
          width="316"
          height="219"
          loading="lazy"
        />
      </div>
    </FooterThreeDesktopCont>
  );
};

export default FooterThreeDesktop;
